import api, { generateRequestHeader } from './api'

const URLS = {
  applicants: '/applicants'
}

export const getApplicants = (query, config) => {
  return api.get(URLS.applicants, {
    ...config,
    params: { ...query },
    headers: generateRequestHeader('admin')
  })
}

export const getApplicant = (query, config, id) => {
  return api.get(URLS.applicants + '/' + id, {
    ...config,
    params: { ...query },
    headers: generateRequestHeader('admin')
  })
}
